/**
 * Throws an error meant to trigger the cart shuffling timeout error path.
 * This assumes that nothing else will handle an error thrown in this function.
 */
export function triggerCartShuffleTimeoutErrorPath() {
  throw new Error(CART_SHUFFLE_TIMEOUT_ERROR_MESSAGE);
}

export const CART_SHUFFLE_TIMEOUT_ERROR_MESSAGE = 'Shuffling cart timeout';
